import _getIterator from 'babel-runtime/core-js/get-iterator';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import LineChart from '@/components/LineChart';
import { getPlayable } from '@/api/dashboard/overview';
import { format } from 'date-fns';

export default {
  props: {
    items: Array
  },
  components: {
    LineChart: LineChart
  },
  data: function data() {
    return {
      channels: ['MSDK', 'DSP'],
      // impression, click ,install
      rawDataSelectedChannels: ['MSDK'],
      // ctr,cvr,ivr
      ratioSelectedChannels: ['MSDK'],
      // offers
      offersSelectedChannels: ['MSDK'],
      loading: true,
      dataSource: []
    };
  },
  mounted: function mounted() {
    this.initData();
  },

  methods: {
    initData: function initData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getPlayable();

              case 2:
                res = _context.sent;

                _this.dataSource = _.get(res, 'data.data.items');
                _this.loading = false;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  computed: {
    rawDataOptions: function rawDataOptions() {
      var dataSource = this.dataSource,
          rawDataSelectedChannels = this.rawDataSelectedChannels;

      var legend = ['imp', 'click', 'install', 'rev'];
      var series = [];
      var xAxisData = [];
      legend.forEach(function (s) {
        series.push({
          name: s,
          type: 'line',
          data: []
        });
      });

      dataSource.forEach(function (data) {
        if (!rawDataSelectedChannels.includes(data.traffic)) return;
        var date = format(data.date, 'MM/DD');
        if (!xAxisData.includes(date)) xAxisData.push(date);

        var _loop = function _loop(_key) {
          var serieIndex = series.findIndex(function (s) {
            return s.name === _key;
          });
          var dateIndex = xAxisData.findIndex(function (d) {
            return d === date;
          });
          if (_key === 'imp') _key = 'impression';
          if (_key === 'rev') _key = 'revenue';
          var value = data[_key];
          if (_key === 'revenue') value = value / 1000;
          if (dateIndex === -1) {
            series[serieIndex].data.push(value);
          } else {
            if (series[serieIndex].data[dateIndex]) {
              series[serieIndex].data[dateIndex] += value;
            } else {
              series[serieIndex].data[dateIndex] = value;
            }
          }
          key = _key;
        };

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _getIterator(legend), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            _loop(key);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });

      return {
        title: {
          text: '最近30天playable投放数据'
        },
        legend: {
          data: legend
        },
        xAxis: {
          data: xAxisData
        },
        series: series
      };
    },
    ratioOptions: function ratioOptions() {
      var dataSource = this.dataSource,
          ratioSelectedChannels = this.ratioSelectedChannels;

      var computedData = function computedData(key, item) {
        var impression = item.impression,
            install = item.install,
            click = item.click;

        switch (key) {
          case 'ctr':
            return (click / impression * 100).toFixed(2);
          case 'cvr':
            return (install / click * 100).toFixed(2);
          case 'ivr':
            return (install / impression * 100).toFixed(2);
          default:
            return '/';
        }
      };
      var legend = ['ctr', 'cvr', 'ivr'];
      var xAxisData = [];
      var series = [];
      var tempData = [];
      dataSource.forEach(function (data) {
        // eslint-disable-next-line prefer-const
        var traffic = data.traffic,
            date = data.date,
            click = data.click,
            impression = data.impression,
            install = data.install;

        if (!ratioSelectedChannels.includes(traffic)) return;
        date = format(data.date, 'MM/DD');
        if (!xAxisData.includes(date)) xAxisData.push(date);
        var tempDataIndex = tempData.findIndex(function (td) {
          return td.date === date;
        });
        if (tempDataIndex === -1) {
          tempData.push({
            date: date,
            click: click,
            impression: impression,
            install: install
          });
        } else {
          var td = tempData[tempDataIndex];
          tempData[tempDataIndex] = {
            date: date,
            click: td.click + click,
            impression: td.impression + impression,
            install: td.install + install
          };
        }
      });

      tempData.forEach(function (td) {
        legend.forEach(function (key) {
          var seriesIndex = series.findIndex(function (s) {
            return s.name === key;
          });
          if (seriesIndex === -1) {
            series.push({
              name: key,
              type: 'line',
              data: [computedData(key, td)]
            });
          } else {
            series[seriesIndex].data.push(computedData(key, td));
          }
        });
      });
      return {
        title: {
          text: '最近30天playable投放数据'
        },
        yAxis: {
          axisLabel: {
            formatter: '{value}%'
          }
        },
        xAxis: {
          data: xAxisData
        },
        legend: {
          data: legend
        },
        series: series
      };
    },
    offersOptions: function offersOptions() {
      var dataSource = this.dataSource,
          offersSelectedChannels = this.offersSelectedChannels;

      var series = [{
        name: 'offers',
        type: 'line',
        data: []
      }];
      var xAxisData = [];
      dataSource.forEach(function (data) {
        if (!offersSelectedChannels.includes(data.traffic)) return;
        var date = format(data.date, 'MM/DD');
        var dateIndex = xAxisData.findIndex(function (d) {
          return d === date;
        });
        if (dateIndex === -1) {
          series[0].data.push(data.offers);
          xAxisData.push(date);
        } else {
          series[0].data[dateIndex] += data.offers;
        }
      });
      return {
        title: {
          text: '最近30天playable的offer数量'
        },
        xAxis: {
          data: xAxisData
        },
        series: series
      };
    }
  }
};